export type SingleNumber = {
	bAccountId: string;
	upAccountId: string;
	accountNum: string;
	userId: string;
	username: string;
	departmentId?: string;
	billingId?: string;
	billingType?: string;
	accountType?: string;
};

const model: types.models.InputModel = {
	upAccountId: 'upAccountId',
	accountNum: 'accountNum',
	userId: 'userId',
	username: 'username',
	departmentId: 'departmentId',
	billingId: 'billingId',
	billingType: 'billingType',
	accountType: 'accountType',
};

export default model;
